import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ReportsFilterItem } from './reportsApi';

export interface ReportQuerySort {
  field: 'sightingDate';
  direction: 'asc' | 'desc';
}

export interface ReportQueryState {
  filters: ReportsFilterItem[];
  page: number;
  pageSize: number;
  sort: ReportQuerySort;
}

const initialState: ReportQueryState = {
  filters: [],
  page: 0,
  pageSize: 10,
  sort: {
    field: 'sightingDate',
    direction: 'desc',
  },
};

const reportQuerySlice = createSlice({
  name: 'reportQuery',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<ReportsFilterItem[]>) {
      state.filters = action.payload;
      state.page = 0;
    },
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pageSize = Math.min(action.payload, 100);
      state.page = 0;
    },
    setSort(state, action: PayloadAction<ReportQuerySort>) {
      state.sort = action.payload;
      state.page = 0;
    },
  },
});

export const { setFilters, setPage, setPageSize, setSort } = reportQuerySlice.actions;
export default reportQuerySlice.reducer;
